import api from "./api";

export const adminService = {
  getAllAdmins: (page = 1, limit = 10) => api.get(`/admin?page=${page}&limit=${limit}`),
  getAdminById: (id) => api.get(`/admin/${id}`),
  createAdmin: (data) => api.post("/admin", data),
  updateAdmin: (id, data) => api.put(`/admin/${id}`, data),
  deleteAdmin: (id) => api.delete(`/admin/${id}`),
};

